import { useState, useEffect } from 'react'

/**
 * Observes the parent element of the given ref and returns its dimensions.
 * Updates reactively via ResizeObserver whenever the parent resizes.
 *
 * @param {React.RefObject} ref - Ref attached to a child element whose parent will be measured.
 * @returns {{ width: number, height: number }} Rounded dimensions of the parent element.
 */
export default function useParentSize(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const parent = ref.current?.parentElement
    if (!parent) return

    const observer = new window.ResizeObserver(([entry]) => {
      setSize({
        width: Math.round(entry.contentRect.width),
        height: Math.round(entry.contentRect.height),
      })
    })

    observer.observe(parent)
    return () => observer.disconnect()
  }, [ref])

  return size
}
